import React from 'react';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import Checkbox from '../forms/Checkbox';

const DefaultHeader = ({
    columns,
    selectable,
    sort,
    sortDirection,
    changeSort,
    smallColumns = [],
    largeColumns = [],
    selectAll,
    selectAllChecked,
    selectAllHalfChecked
}) => (
    <thead className="ckp-tables-header">
        <tr className="ckp-tables-header-row">
            {selectable ? (
                <th className="ckp-tables-select-column">
                    {selectAll && (
                        <Checkbox
                            name={'ckp-table-header-checkbox'}
                            checked={selectAllChecked}
                            halfChecked={selectAllHalfChecked}
                            onChange={selectAll}
                        />
                    )}
                </th>
            ) : null}
            {columns.map(c => (
                <th
                    key={c.key}
                    onClick={sort && !c.disableSort ? () => changeSort(c.key) : null}
                    className={`ckp-tables-header-column u-truncate ${smallColumns.includes(c.key) ? 'is-small' : ''} ${
                        largeColumns.includes(c.key) ? 'is-large' : ''
                    } ${sort ? 'u-clickable' : ''}`}
                >
                    {c.label}
                    {c.key === sort ? (
                        sortDirection === 'asc' || !sortDirection ? (
                            <ArrowDropUp />
                        ) : (
                            <ArrowDropDown />
                        )
                    ) : null}
                </th>
            ))}
        </tr>
    </thead>
);

export default DefaultHeader;
